import React, { useState } from "react";

import { Container, ContentContainer, Title } from "./styles";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import ThemeProvider from "./components/ThemeProvider";
import FilterOptions from "./components/FilterOptions";
import QuestionsResults from "./components/QuestionsResults";

export default function TestsResults() {
  const [selectedTest, setSelectedTest] = useState();
  const [selectedCourse, setSelectedCourse] = useState();

  return (
    <ThemeProvider>
      <Container>
        <AdminMenu />
        <ContentContainer>
          <Title>Resultados do Consolidando Conhecimento</Title>
          <FilterOptions
            selectedCourse={selectedCourse}
            selectedTest={selectedTest}
            onChangeSelectedCourse={setSelectedCourse}
            onChangeSelectedTest={setSelectedTest}
          />
          {selectedCourse && selectedTest && (
            <QuestionsResults
              courseID={selectedCourse?.id}
              testJSID={selectedTest?.id}
              questions={selectedTest?.questions}
            />
          )}
        </ContentContainer>
      </Container>
    </ThemeProvider>
  );
}
